<template>
  <div class="container">        
        <div class="row">
            <div class="col-12">
                <div class="table-responsive mt-5 mb-5">
                    <table class="table table-hover">                        
                        <tbody>
                            <tr>
                                <th class="tg-yw4l">Hora</th>
                                <th class="tg-yw4l">Domingo</th>
                                <th class="tg-yw4l">Lunes</th>
                                <th class="tg-yw4l">Martes</th>
                                <th class="tg-yw4l">Miércoles</th>
                                <th class="tg-yw4l">Jueves</th>
                                <th class="tg-yw4l">Viernes</th>
                                <th class="tg-yw4l">Sábado</th>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">12:00 a.m.</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">6:00 a.m.</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">8:00 a.m.</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                                <td class="tg-yw4l">Prosa y Poesía</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">9:30 a.m.</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">10:00 a.m.</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">12:00 p.m.</td>
                                <td class="tg-yw4l"></td>
                                <td class="tg-yw4l">Tesoros del Reino</td>
                                <td class="tg-yw4l">Tesoros del Reino</td>
                                <td class="tg-yw4l">Supremo Llamamiento</td>
                                <td class="tg-yw4l">Eleva tu Visión</td>
                                <td class="tg-yw4l">Caminando por la Senda Antigua</td>
                                <td class="tg-yw4l">Tu Historia Preferida</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">1:00 p.m.</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                                <td class="tg-yw4l">La Insignia Real</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">2:00 p.m.</td>
                                <td class="tg-yw4l">Una Mesa en el desierto</td>
                                <td class="tg-yw4l">Una Mesa en el desierto</td>
                                <td class="tg-yw4l">Una Mesa en el desierto</td>
                                <td class="tg-yw4l">Una Mesa en el desierto</td>
                                <td class="tg-yw4l">Una Mesa en el desierto</td>
                                <td class="tg-yw4l">Una Mesa en el desierto</td>
                                <td class="tg-yw4l">Una Mesa en el desierto</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">2:30 p.m.</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                                <td class="tg-yw4l">Cuán Bella Historia</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">6:00 p.m.</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                                <td class="tg-yw4l">De Rodillas Triunfamos</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">6:15 p.m.</td>                        
                                <td class="tg-yw4l"></td>
                                <td class="tg-yw4l">Tesoros del Reino</td>
                                <td class="tg-yw4l">Tesoros del Reino</td>
                                <td class="tg-yw4l">Supremo Llamamiento</td>
                                <td class="tg-yw4l">Eleva tu Visión</td>
                                <td class="tg-yw4l">Caminando por la Senda Antigua</td>
                                <td class="tg-yw4l"></td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">8:00 p.m.</td>
                                <td class="tg-yw4l">Una Mesa en el Desierto</td>
                                <td class="tg-yw4l">Una Mesa en el Desierto</td>
                                <td class="tg-yw4l">Una Mesa en el Desierto</td>
                                <td class="tg-yw4l">Una Mesa en el Desierto</td>
                                <td class="tg-yw4l">Una Mesa en el Desierto</td>
                                <td class="tg-yw4l">Una Mesa en el Desierto</td>
                                <td class="tg-yw4l">Una Mesa en el Desierto</td>
                            </tr>
                            <tr>
                                <td class="tg-yw4l">8:00 p.m. - 3:00 a.m.</td>
                                <td class="tg-yw4l">Musica Instrumental</td>
                                <td class="tg-yw4l">Musica Instrumental</td>
                                <td class="tg-yw4l">Musica Instrumental</td>
                                <td class="tg-yw4l">Musica Instrumental</td>
                                <td class="tg-yw4l">Musica Instrumental</td>
                                <td class="tg-yw4l">Musica Instrumental</td>
                                <td class="tg-yw4l">Musica Instrumental</td>
                            </tr>
                        </tbody>
                    </table>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>